/**
 * Converts a non-negative integer into its Base32 string representation
 * using a Crockford-style alphabet (digits + uppercase letters, excluding I, L, O, U).
 *
 * @param {number} number - The integer to convert.
 * @returns {string} The Base32-encoded string, or '0' if the input is 0 or less.
 */
export function toBase32(number) {
  const alphabet = '0123456789ABCDEFGHJKMNPQRSTVWXYZ';
  let result = '';
  while (number > 0) {
    result = alphabet[number % 32] + result;
    number = Math.floor(number / 32);
  }
  return result || '0';
}
